import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register-communications-advise',
  templateUrl: './register-communications-advise.component.html',
  styleUrls: ['./register-communications-advise.component.scss'],
})
export class RegisterCommunicationsAdviseComponent implements OnInit {

  @Output() public btnEvent = new EventEmitter<any>();

  advise = this.translate.instant('NOTIFICATIONS.ADVISE_TEXT');

  constructor(public chdRef: ChangeDetectorRef, private translate: TranslateService) { }

  ngOnInit() {

  }

  activate(val) {
    this.btnEvent.emit(val);
    this.chdRef.detectChanges();
  }

}
